/* ============================================================================
   DY COMPONENTS JS — versión segura
   ========================================================================= */

(() => {
  'use strict';

  // Textos traducidos que entrega layout/theme.liquid (window.DYStrings); español como respaldo
  const dyT = (key, fallback) => (window.DYStrings && window.DYStrings[key]) || fallback;

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollReveal() {
    const els = Array.from(document.querySelectorAll('[data-dy-reveal]'));
    if (!els.length) return;
    if (REDUCED) {
      els.forEach((el) => el.classList.add('dy-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('dy-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.01 }
    );
    els.forEach((el) => io.observe(el));
    setTimeout(() => els.forEach((el) => el.classList.add('dy-in')), 2200);
  }

  function announcementRotator() {
    const bars = document.querySelectorAll('.header-announcements, .announcement-bar');
    bars.forEach((bar) => {
      if (bar.dataset.dyRotate === '1') return;
      const items = Array.from(bar.children).filter(
        (el) => el.matches('a, span, p, div') && el.textContent.trim().length
      );
      if (items.length < 2) return;
      bar.dataset.dyRotate = '1';
      bar.classList.add('dy-announce-rotator');
      items.forEach((el, i) => {
        el.classList.add('dy-announce-rotator__slide');
        if (i === 0) el.classList.add('is-active');
      });
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 5000);
    });
  }

  window.DYToast = function DYToast(msg) {
    let t = document.querySelector('.dy-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'dy-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg || dyT('added_to_bag', 'Añadido a la bolsa');
    requestAnimationFrame(() => t.classList.add('is-in'));
    clearTimeout(t._to);
    t._to = setTimeout(() => t.classList.remove('is-in'), 2600);
  };

  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"]')) {
      setTimeout(() => window.DYToast(dyT('added_to_bag', 'Añadido a la bolsa')), 300);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('dialog[open]').forEach((d) => d.close?.());
  });

  function forceHeroVideo() {
    document.querySelectorAll('[data-dy-hero] video').forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const play = () => video.play().catch(() => {});
      play();
      video.addEventListener('loadeddata', play, { once: true });
    });
  }

  function nativeProductCarousels() {
    const carousels = document.querySelectorAll('.resource-list__carousel slideshow-component');
    carousels.forEach((slideshow) => {
      const scroller = slideshow.querySelector('slideshow-slides');
      if (!scroller || scroller.dataset.dyNative === '1') return;
      scroller.dataset.dyNative = '1';
      scroller.style.scrollBehavior = 'auto';
      scroller.style.webkitOverflowScrolling = 'touch';
      scroller.addEventListener(
        'touchstart',
        () => {
          scroller.style.scrollSnapType = 'none';
        },
        { passive: true }
      );
      let settle;
      scroller.addEventListener(
        'touchend',
        () => {
          clearTimeout(settle);
          settle = setTimeout(() => {
            scroller.style.scrollSnapType = 'x mandatory';
          }, 80);
        },
        { passive: true }
      );
    });
  }

  const WISHLIST_KEY = 'dy_wishlist';

  function readWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(raw) ? raw.map(String) : [];
    } catch {
      return [];
    }
  }

  function writeWishlist(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent('dy:wishlist:change', { detail: { ids } }));
  }

  function isWishlisted(id) {
    return readWishlist().includes(String(id));
  }

  function toggleWishlist(id) {
    const key = String(id);
    const ids = readWishlist();
    const index = ids.indexOf(key);
    if (index >= 0) {
      ids.splice(index, 1);
      writeWishlist(ids);
      return false;
    }
    ids.push(key);
    writeWishlist(ids);
    return true;
  }

  function syncWishlistButtons(root = document) {
    root.querySelectorAll('[data-dy-wishlist][data-product-id]').forEach((btn) => {
      const active = isWishlisted(btn.dataset.productId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = active
        ? dyT('remove_from_wishlist', 'Quitar de lista de deseos')
        : dyT('add_to_wishlist', 'Añadir a lista de deseos');
      btn.setAttribute('aria-label', label);
    });
  }

  function syncWishlistBadge() {
    const count = readWishlist().length;
    const label =
      count > 0
        ? dyT('wishlist_count', 'Lista de deseos, [count] productos').replace('[count]', count)
        : dyT('wishlist', 'Lista de deseos');

    document.querySelectorAll('[data-dy-wishlist-badge]').forEach((badge) => {
      const countEl = badge.querySelector('[data-dy-wishlist-count]');
      if (!countEl) return;

      const prev = parseInt(countEl.dataset.count || '0', 10);
      const text = count <= 0 ? '' : count > 99 ? '99+' : String(count);

      countEl.textContent = text;
      countEl.dataset.count = String(count);
      countEl.classList.toggle('hidden', count === 0);
      badge.classList.toggle('visually-hidden', count === 0);
      badge.toggleAttribute('data-maintain-ratio', count > 0 && count < 10);

      if (count > prev && count > 0) {
        badge.classList.add('dy-count-bubble--pop');
        badge.addEventListener(
          'animationend',
          () => badge.classList.remove('dy-count-bubble--pop'),
          { once: true }
        );
      }
    });

    document.querySelectorAll('[data-dy-wishlist-trigger]').forEach((trigger) => {
      trigger.classList.toggle('header-actions__wishlist--has-items', count > 0);
      trigger.setAttribute('aria-label', label);
    });
  }

  function syncWishlist() {
    syncWishlistButtons();
    syncWishlistBadge();
  }

  function bindWishlist() {
    if (document.documentElement.dataset.dyWishlistBound === '1') return;
    document.documentElement.dataset.dyWishlistBound = '1';

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-dy-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const id = btn.dataset.productId;
      if (!id) return;
      const active = toggleWishlist(id);
      syncWishlist();
      if (window.DYToast) {
        window.DYToast(
          active
            ? dyT('added_to_wishlist', 'Añadido a lista de deseos')
            : dyT('removed_from_wishlist', 'Eliminado de lista de deseos')
        );
      }
    });

    window.addEventListener('dy:wishlist:change', () => syncWishlist());
    document.addEventListener('shopify:section:load', () => syncWishlist());
  }

  function updateScrollbarWidth() {
    if (document.documentElement.hasAttribute('scroll-lock')) return;
    const width = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }

  function bindScrollLockStability() {
    if (document.documentElement.dataset.dyScrollLockBound === '1') return;
    document.documentElement.dataset.dyScrollLockBound = '1';

    updateScrollbarWidth();
    window.addEventListener('resize', updateScrollbarWidth, { passive: true });

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!(event.target instanceof Element)) return;
        if (
          event.target.closest(
            '.menu-drawer-container summary, .header__icon--menu, [scroll-lock], search-modal, cart-drawer-component'
          )
        ) {
          updateScrollbarWidth();
        }
      },
      true
    );

    const observer = new MutationObserver(() => {
      if (!document.documentElement.hasAttribute('scroll-lock')) {
        updateScrollbarWidth();
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scroll-lock'],
    });
  }

  function init() {
    scrollReveal();
    announcementRotator();
    forceHeroVideo();
    nativeProductCarousels();
    bindWishlist();
    syncWishlist();
    bindScrollLockStability();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.DYWishlist = {
    get: readWishlist,
    has: isWishlisted,
    toggle: toggleWishlist,
    sync: syncWishlist,
    syncButtons: syncWishlistButtons,
    syncBadge: syncWishlistBadge,
  };
})();
